export const I18n = {
	'en': {
		companyTitle: 'Company',
		email: 'Email',
		phone: 'Phone',
		name: 'Name',
		type: 'Type',
		country: 'Country',
		city: 'City',
		manager: 'Manager',
		skype: 'Skype',
		status: 'Status',
		statusPending: 'Pending',
		statusBlocked: 'Blocked',
		statusActive: 'Active',
		noStatus: 'None',
		defaultPasswd: 'Default password',
		cancel: 'Cancel',
		save: 'Save',
		companyTraders: 'Traiders network',
		companyDev: 'Developer',
		companyLogo: 'Company logo',
		logoIsTooLarge: 'The logo is too large',
		isNotAnImage: 'Selected file isn\'t an image',
		deleteLogoQuestion: "Are you sure you want to remove the logo?",
		yes: "Yes",
		no: "No",
		logoWasDeleted: "Your logo was deleted",
		choose: "Choose",
		deleteLogo: "Delete logo",
		contactUsToAccessThis: "Contact info@hankuper.com to access this functionality",
		language: "Language",
	},
	'ru': {
		companyTitle: 'Компания',
		email: 'Э-л почта',
		phone: 'Номер телефона',
		name: 'Название',
		type: 'Тип',
		country: 'Страна',
		city: 'Город',
		manager: 'Менеджер',
		skype: 'Скайп',
		status: 'Status',
		statusPending: 'Pending',
		statusBlocked: 'Blocked',
		statusActive: 'Active',
		noStatus: 'None',
		defaultPasswd: 'Пароль по умолчанию',
		cancel: 'Отмена',
		save: 'Сохранить',
		companyTraders: 'Торговая сеть',
		companyDev: 'Разработчик',
		companyLogo: 'Лого компании',
		logoIsTooLarge: 'Лого слишком большого размера',
		isNotAnImage: 'Выбранный файл не является изображением',
		deleteLogoQuestion: "Вы уверены, что хотите удалить лого?",
		yes: "Да",
		no: "Нет",
		logoWasDeleted: "Ваше лого было удалено",
		choose: "Выбрать",
		deleteLogo: "Удалить лого",
		contactUsToAccessThis: "Для доступа к данному функционалу - обратитесь по адресу info@hankuper.com",
		language: "Язык",
	},
	'sk': {
		companyTitle: 'Spoločnosť',
		email: 'E-mail',
		phone: 'Telefón',
		name: 'Názov',
		type: 'Typ',
		country: 'Krajina',
		city: 'Veľkomesto',
		manager: 'Manažér',
		skype: 'Skype',
		status: 'Postavenie',
		statusPending: 'Nevykonaného',
		statusBlocked: 'Upchatý',
		statusActive: 'Aktívny',
		noStatus: 'Nikto',
		defaultPasswd: 'Predvolené heslo',
		cancel: 'Zrušiť',
		save: 'Uložiť',
		companyTraders: 'Traiders siete',
		companyDev: 'Vývojka',
		companyLogo: 'Logo spoločnosti',
		logoIsTooLarge: 'Logo je príliš veľké',
		isNotAnImage: 'Vybratý súbor nie je obrázok',
		deleteLogoQuestion: "Naozaj chcete odstrániť logo?",
		yes: 'áno',
		no: 'žiadny',
		logoWasDeleted: "Vaše logo bolo odstránené",
		choose: "Vyberte si",
		deleteLogo: "Odstrániť logo",
		contactUsToAccessThis: "Ak chcete získať prístup k tejto funkcii, kontaktujte info@hankuper.com",
		language: "Jazyk",
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/Company/index.js